module.exports = __webpack_public_path__ + "media/metronic/_theme/media/client-logos/logo3-9c9b6abefcc28134e807e0f2cb93acd6.png";